export interface ISystemConfigInfo {
	Enquiry?: {
		SaleEnquiryTaskTypes?: string;
		RentalEnquiryTaskTypes?: string;
		ValuationRequestTaskTypes?: string;
		GeneralInfoTaskTypes?: string;
		DefaultSalesViewingAppointmentType?: string;
		DefaultRentalViewingAppointmentType?: string;
		DefaultValuationAppointmentType?: string;
		AutoFillFirstOwnerTaskTypes?: string;
	};
	Tasks?: {
		AutoAssignManagerTaskTypes?: string;
		/** FRO-11207: true keeps Enquiry Centre task types available in the Tasks module (skips the FRO-11045 hiding) */
		FilterECTaskType?: boolean;
	};
	/** BAC-3515: comma-separated EnumValues keys of the status/substatus base types that count as Sold/Rented */
	PropertyStatus?: {
		SoldStatusBaseTypes?: string;
		RentedStatusBaseTypes?: string;
		SoldSubStatusBaseTypes?: string;
		RentedSubStatusBaseTypes?: string;
	};
}

/** Config values hold comma-separated TaskTypes ids (e.g. "51,86,89") */
export function parseTaskTypeIds(configValue: string): number[] {
	return (configValue || "")
		.split(",")
		.map(id => parseInt(id, 10))
		.filter(id => !isNaN(id));
}

/** Task types owned by the Enquiry Centre (FRO-11045): shown when creating an enquiry, hidden when creating a normal task */
export function getEnquiryTaskTypeIds(info: ISystemConfigInfo): number[] {
	return [
		...parseTaskTypeIds(info?.Enquiry?.SaleEnquiryTaskTypes),
		...parseTaskTypeIds(info?.Enquiry?.RentalEnquiryTaskTypes),
		...parseTaskTypeIds(info?.Enquiry?.ValuationRequestTaskTypes),
		...parseTaskTypeIds(info?.Enquiry?.GeneralInfoTaskTypes)
	];
}

export interface IAppConfigState {
	formDataConfigs: Object;
	systemAppConfigs: Object;
	userAppConfigs: Object;
	systemConfigInfo: ISystemConfigInfo;
}

export const APP_CONFIG_MODULE_TYPES = {
    GET_FORM_DATA_CONFIG_BY_TYPE: 'getFormDataConfigByType',
	UPDATE_CONFIG_VALUE: 'updateConfigValue',
	GET_SYSTEM_CONFIG: 'getSystemConfig',
    GET_USER_CONFIG: 'getUserConfig',
    SET_USER_CONFIG: 'setUserConfig',
    SET_SYSTEM_CONFIG: 'setSystemConfig',
    GET_SYSTEM_CONFIG_INFO: 'getSystemConfigInfo',
    SET_SYSTEM_CONFIG_INFO: 'setSystemConfigInfo'
}

export const COMMON_CONFIG_KEYS = {
	POPULAR_EMAIL_DOMAIN: 'PopularEmailDomains'
}